export const BASE_DATA = {
  OFFICE: "office-address",
  WINGS: "units",
  DESIGNATIONS: "positions",
  POSITIONS: "unit-positions",
  GRADES: "employee-grades",
  UNIT_TREE: "unittree",
  POST_TYPE: "postType"
};
